module.exports = __webpack_public_path__ + "static/grid-c-48035b950ba7d0d3aab055c0f86fb3be.jpg";